// @i18n-ignore-file
import { IStatsigExperiment } from '@src/experiments/experiments.types'

export enum STATSIG_EXPERIMENTS {
  BANNER_A_CLP_A_V_A_EXPERIMENT = 'banner-a-clp-a-v-clp-a',
  MWEB_APP_BANNER = 'mweb-app-banner',
  EXPRESS_CHECKOUT_IN_CART = 'express-checkout-in-cart',
  SECOND_RETURNS_CHARGING = 'second-returns-charging',
  CONTACT_US_LINK_EXPERIMENT = 'contact-us-link',
  TRACKING_PAGE_CONTACT_US = 'tracking-page-contact-us',
  EDD = 'edd',
  NEW_CLP_FILTERS_DWEB = 'new-clp-filters-dweb',
  NEW_CLP_FILTERS_MWEB = 'new-clp-filters-mweb',
  EXCHANGE_FOR_ANYTHING = 'exchange-for-anything',
  EXCHANGE_FOR_ANYTHING_V2 = 'exchange-for-anything-v2',
  PROGRESSIVE_DISCLOSURE = 'progressive-disclosure',
  PROGRESSIVE_DISCLOSURE_V2 = 'progressive-disclosure-v2',
  NEW_CART_RECOMMENDATIONS = 'new-cart-recommendations',
  RECENTLY_VIEWED_CART = 'recently-viewed-cart',
  RETURN_LESS_REFUND = 'return-less-refund',
  PERSONALISED_EXPLORE_EVERYTHING = 'personalized-explore-everything',
  FEATURE_SECTION_2_DESIGN = 'feature-section-2-design',
  CLP_PERSONALISATION = 'clp_personalisation',
  PDP_TAG_VISIBILITY = 'pdp-tag-visibility',
  ENABLE_NEW_IDME_DISCOUNT_API = 'enable-new-idme-discount-api',
  OOS_CART = 'out-of-stock-cart',
  PERSONALIZED_BESTSELLER = 'personalized_best_seller_v3',
  MWEB_EXPOSED_SEARCH = 'mweb-exposed-search',
  REFUND_OPTIONS_REDESIGN = 'refund_options_redesign',
  CHECKOUT_REDESIGN = 'checkout-redesign',
  POST_ATC = 'post-atc',
  A_A_LOCALISATION_ALL = 'a_a_localisation_all',
  A_A_LOCALISATION_CA_ONLY = 'a_a_localisation_ca_only',
  A_A_LOCALISATION_US_ONLY = 'a_a_localisation_usa_only',
  ENABLE_USA_LOCALISATION = 'enable_localisation_usa',
  ENABLE_LOCALISATION_DROPDOWN = 'enable-localisation-dropdown',
  CHAT_PROVIDER_DEFAULT = 'chat-provider-default',
  MINI_PDP_EXPERIMENT = 'mini-pdp-web',
  SIGN_IN_WITH_CODE = 'login-via-code',
  CART_EDD = 'cart_edd',
  EXPERIMENT_HOMEPAGE_WEB = 'experiment_homepage_web',
  EXPERIMENT_HOMEPAGE_MOBILE = 'experiment_homepage_mobile',
  EXPERIMENT_HOMEPAGE_DESKTOP = 'experiment_homepage_desktop',
  VELOU_FILTERS = 'velou_filters',
  PDP_MODEL_SIZE_TAG_VISIBILITY = 'pdp-model-size-tag-visibility',
  BEST_SELLING_COLORS_ORDERING = 'best-selling-colors-ordering',
  USE_ULTRA_LITE = 'use-ultra-lite',
  NEW_PDP_DESIGN_V2 = 'new-pdp-design-v2',
  SAVE_PARTIAL_CHECKOUT = 'save-partial-checkout',
  CART_SAVINGS_PRESENTATION = 'cart-savings-presentation',
  PDP_REVIEW_SYSTEM_V3 = 'web-pdp-review-system-v3',
  CLP_RANKING_2_7_WEB = 'clp-ranking-2_7-web',
  CLP_AA_TEST_WITH_QUALIFYING_EVENT = 'clp_aa_test_with_qualifying_event',
  CLP_AA_TEST_WITHOUT_QUALIFYING_EVENT = 'clp_aa_test_without_qualifying_event',
  CLP_AA_TEST_WITH_EXPOSURE_DISABLED = 'clp_aa_test_with_exposure_disabled',
  EXPERIMENT_HOMEPAGE_DESIGN_SYSTEM = 'experiment_home-design-system',
  CLP_PL_USER_ROLLOUT_CONTROL = 'clp-pl-user-rollout-control',
  CANADA_SITE_DUTY_MESSAGE = 'canada-site-duty-message',
}

export enum STATSIG_EXPERIMENTS_BUCKETS {
  CONTROL = 'control',
  SHOW = 'show',
  GROUP_A = 'groupA',
  GROUP_B = 'groupB',
  GROUP_C = 'groupC',
  GROUP_D = 'groupD',
  TEST = 'test',
  TEST_A = 'testA',
  CONTROL_CAP = 'Control',
  SHOWA_CAP = 'ShowA',
  SHOWB_CAP = 'ShowB',
  TEST_CAP = 'Test',
}
export const STATSIG_NO_FALLBACK_EXPERIMENTS = new Set<STATSIG_EXPERIMENTS>([
  STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER,
])

export const STATSIG_DEFAULT_CONTROL_SHOW_SETUP = {
  defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
  buckets: {
    control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
  },
}

export const STATSIG_EXPERIMENTS_CONFIG: Record<STATSIG_EXPERIMENTS, IStatsigExperiment> = {
  [STATSIG_EXPERIMENTS.EXCHANGE_FOR_ANYTHING]: {
    experimentName: 'exchange-for-anything',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
    defaultBucket: 'Control',
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.EXCHANGE_FOR_ANYTHING_V2]: {
    experimentName: 'exchange-for-anything-v2',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
    defaultBucket: 'Control',
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.PROGRESSIVE_DISCLOSURE]: {
    experimentName: 'progressive-disclosure',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'TestA',
      testB: 'TestB',
    },
  },
  [STATSIG_EXPERIMENTS.PROGRESSIVE_DISCLOSURE_V2]: {
    experimentName: 'progressive-disclosure-v2',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'TestA',
      testB: 'TestB',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_CART_RECOMMENDATIONS]: {
    experimentName: 'new-cart-recommendations',
    defaultBucket: 'Control',
    buckets: {
      test: 'Test',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.RETURN_LESS_REFUND]: {
    experimentName: 'return-less-refund',
    defaultBucket: 'Control',
    buckets: {
      show: 'Test',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.BANNER_A_CLP_A_V_A_EXPERIMENT]: {
    experimentName: 'banner-a-clp-a-v-clp-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.SECOND_RETURNS_CHARGING]: {
    experimentName: 'second-returns-charging',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EXPRESS_CHECKOUT_IN_CART]: {
    experimentName: 'express-checkout-in-cart',
    defaultBucket: 'control',
    buckets: {
      testA: 'testA',
      testB: 'testB',
      control: 'control',
    },
  },
  [STATSIG_EXPERIMENTS.CONTACT_US_LINK_EXPERIMENT]: {
    experimentName: 'contact-us-link',
    defaultBucket: 'Control',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.PDP_TAG_VISIBILITY]: {
    experimentName: 'pdp-tag-visibility',
    buckets: {
      control: 'control',
      groupA: 'groupA',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.ENABLE_NEW_IDME_DISCOUNT_API]: {
    experimentName: 'enable-new-idme-discount-api',
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EDD]: {
    experimentName: 'edd',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },

  [STATSIG_EXPERIMENTS.SAVE_PARTIAL_CHECKOUT]: {
    experimentName: 'save-partial-checkout',
    defaultBucket: 'Test',
    buckets: {
      Control: 'Control',
      Test: 'Test',
    },
    defaultB2BBucket: 'Test',
  },
  [STATSIG_EXPERIMENTS.NEW_CLP_FILTERS_DWEB]: {
    experimentName: 'new-clp-filters-dweb',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
      groupC: STATSIG_EXPERIMENTS_BUCKETS.GROUP_C,
      groupD: STATSIG_EXPERIMENTS_BUCKETS.GROUP_D,
    },
  },
  [STATSIG_EXPERIMENTS.NEW_CLP_FILTERS_MWEB]: {
    experimentName: 'new-clp-filters-mweb',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.RECENTLY_VIEWED_CART]: {
    experimentName: 'recently-viewed-cart',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      ShowA: 'ShowA',
      ShowB: 'ShowB',
    },
  },
  [STATSIG_EXPERIMENTS.POST_ATC]: {
    experimentName: STATSIG_EXPERIMENTS.POST_ATC,
    defaultBucket: 'Control',
    buckets: {
      Control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
      ShowA: STATSIG_EXPERIMENTS_BUCKETS.SHOWA_CAP,
      ShowB: STATSIG_EXPERIMENTS_BUCKETS.SHOWB_CAP,
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALISED_EXPLORE_EVERYTHING]: {
    experimentName: 'personalized-explore-everything',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.FEATURE_SECTION_2_DESIGN]: {
    experimentName: 'feature-section-2-design',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.TRACKING_PAGE_CONTACT_US]: {
    experimentName: 'tracking-page-contact-us',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Experiment: 'Experiment',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PERSONALISATION]: {
    experimentName: 'clp_personalisation',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER]: {
    experimentName: 'personalized_best_seller_v3',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.OOS_CART]: {
    experimentName: 'out-of-stock-cart',
    defaultBucket: 'control',
    buckets: {
      control: 'Control',
      show: 'Show',
    },
    defaultB2BBucket: 'Show',
  },
  [STATSIG_EXPERIMENTS.MWEB_EXPOSED_SEARCH]: {
    experimentName: 'mweb-exposed-search',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
      groupC: 'groupC',
    },
  },
  [STATSIG_EXPERIMENTS.REFUND_OPTIONS_REDESIGN]: {
    experimentName: 'refund_options_redesign',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: 'Control',
      show: 'Show',
    },
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_REDESIGN]: {
    experimentName: 'checkout-redesign',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_ALL]: {
    experimentName: 'a_a_localisation_all',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_CA_ONLY]: {
    experimentName: 'a_a_localisation_ca_only',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_US_ONLY]: {
    experimentName: 'a_a_localisation_usa_only',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.ENABLE_USA_LOCALISATION]: {
    experimentName: 'enable_localisation_usa',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.ENABLE_LOCALISATION_DROPDOWN]: {
    experimentName: 'enable-localisation-dropdown',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.CHAT_PROVIDER_DEFAULT]: {
    experimentName: 'chat-provider-default',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.MINI_PDP_EXPERIMENT]: {
    experimentName: STATSIG_EXPERIMENTS.MINI_PDP_EXPERIMENT,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.SIGN_IN_WITH_CODE]: {
    experimentName: 'login-via-code',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.CART_EDD]: {
    experimentName: 'cart_edd',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_WEB]: {
    experimentName: 'experiment_homepage_web',
    defaultBucket: 'Control',
    buckets: {
      control: 'control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_MOBILE]: {
    experimentName: 'experiment_homepage_mobile',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_DESKTOP]: {
    experimentName: 'experiment_homepage_desktop',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.VELOU_FILTERS]: {
    experimentName: 'velou_filters',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_MODEL_SIZE_TAG_VISIBILITY]: {
    experimentName: 'pdp-model-size-tag-visibility',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.BEST_SELLING_COLORS_ORDERING]: {
    experimentName: 'best-selling-colors-ordering',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.USE_ULTRA_LITE]: {
    experimentName: 'use-ultra-lite',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.NEW_PDP_DESIGN_V2]: {
    experimentName: 'new-pdp-design-v2',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
      groupC: STATSIG_EXPERIMENTS_BUCKETS.GROUP_C,
    },
  },
  [STATSIG_EXPERIMENTS.CART_SAVINGS_PRESENTATION]: {
    experimentName: 'cart-savings-presentation',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_REVIEW_SYSTEM_V3]: {
    experimentName: 'web-pdp-review-system-v3',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
      groupC: STATSIG_EXPERIMENTS_BUCKETS.GROUP_C,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_RANKING_2_7_WEB]: {
    experimentName: 'clp-ranking-2_7-web',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_AA_TEST_WITH_QUALIFYING_EVENT]: {
    experimentName: 'clp_aa_test_with_qualifying_event',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_AA_TEST_WITHOUT_QUALIFYING_EVENT]: {
    experimentName: 'clp_aa_test_without_qualifying_event',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_AA_TEST_WITH_EXPOSURE_DISABLED]: {
    experimentName: 'clp_aa_test_with_exposure_disabled',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  // testing one of homepage widgets to be implemented with new Design System
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_DESIGN_SYSTEM]: {
    experimentName: STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_DESIGN_SYSTEM,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      testA: STATSIG_EXPERIMENTS_BUCKETS.TEST_A,
    },
  },
  [STATSIG_EXPERIMENTS.CANADA_SITE_DUTY_MESSAGE]: {
    experimentName: 'canada-site-duty-message',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
    buckets: {
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP,
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
    },
  },
  [STATSIG_EXPERIMENTS.MWEB_APP_BANNER]: {
    experimentName: STATSIG_EXPERIMENTS.MWEB_APP_BANNER,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PL_USER_ROLLOUT_CONTROL]: {
    experimentName: STATSIG_EXPERIMENTS.CLP_PL_USER_ROLLOUT_CONTROL,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
}
